import Eyebrow from './Eyebrow';

// Eyebrow + title pair, optional right-side action link.
// Usage: <SectionHeader eyebrow="DRAFT BOARD" title="Keeper Chaos Board." actionLabel="DRAFT ROOM →" />

export default function SectionHeader({ eyebrow, title, actionLabel, actionHref = '#', eyebrowColor = 'gold', className = '' }) {
  return (
    <div className={`flex flex-col sm:flex-row sm:justify-between sm:items-baseline gap-4 mb-8 ${className}`}>
      <div className="min-w-0">
        <Eyebrow color={eyebrowColor}>{eyebrow}</Eyebrow>
        <div className="font-display text-display-xs md:text-display-sm font-black tracking-normal leading-none break-words mt-1.5">{title}</div>
      </div>
      {actionLabel && (
        <a href={actionHref} className="self-start sm:self-auto text-[11px] font-extrabold text-accent-gold tracking-[0.25em] border border-accent-gold px-4 py-3 hover:bg-accent-gold hover:text-bg-base transition-colors whitespace-nowrap">
          {actionLabel}
        </a>
      )}
    </div>
  );
}
